export { default } from './LightboxFooter';
